<section id="quiz" class="wl-section prep">
  <div class="wl-inner inner">
    <app-section-heading
      eyebrow="Przygotowanie quizu"
      title="10 minut i quiz gotowy."
      subtitle="Państwo Młodzi dodają pytania w panelu administracyjnym. Prowadzący zarządza quizem przez prosty interfejs. Goście poznają Was lepiej." />

    <div class="cols">
      <div class="col-questions">
        <p class="col-label">Przykładowe pytania</p>
        <div class="q-list">
          @for (item of questions; track item.q; let i = $index) {
            <div class="q-card">
              <span class="q-num">{{ i + 1 }}</span>
              <div>
                <p class="q-text">{{ item.q }}</p>
                <p class="q-answer">{{ item.a }}</p>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="col-features">
        <p class="col-label">Co daje quiz gościom</p>

        <app-feature-card title="Rozmowy przy stole" text="Odpowiedzi otwierają wątki, o których sami goście nie wiedzieli. Sala się integruje naturalnie.">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B08947" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2v4l-4-4H9a2 2 0 0 1-2-2v-1"/><path d="M15 3H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2v4l4-4h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"/></svg>
        </app-feature-card>

        <app-feature-card title="Śmiech gwarantowany" text="Każde pytanie o Waszą historię to potencjalna anegdota. Odpowiedzi gości są często zaskoczeniem nawet dla Was.">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B08947" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>
        </app-feature-card>

        <app-feature-card title="Poznacie swoich gości" text="Ranking na dużym ekranie pokazuje, kto Was naprawdę zna. I kto myślał, że zna — a się pomylił.">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B08947" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        </app-feature-card>
      </div>
    </div>
  </div>
</section>
